import React from 'react';

const LOGOS = [
  {
    name: 'Fremont Bank',
    alt: 'Fremont Bank logo',
    url: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/ef7682abfaa1eee4c7c56d7a4605d451.png',
    containerClass: 'h-16 md:h-24 max-w-[280px] md:max-w-[320px]',
    filterClass: 'mix-blend-multiply scale-125 md:scale-150 origin-center',
  },
  {
    name: 'Goodwin',
    alt: 'Goodwin Law logo',
    url: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/94475896acdfe22f8080b5083da0a432.png',
    containerClass: 'h-12 md:h-16 max-w-[180px]',
    filterClass: 'brightness-0 grayscale mix-blend-multiply',
  },
  {
    name: 'WRMSDC',
    alt: 'Western Regional Minority Supplier Development Council logo',
    url: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/00b6912e6104bb203424dee5eeb21fa0.png',
    containerClass: 'h-12 md:h-16 max-w-[180px]',
    filterClass: 'brightness-0 grayscale mix-blend-multiply',
  },
  {
    name: 'At Will Media',
    alt: 'At Will Media logo',
    url: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2Uvd2VicA==/374057523b464b16ab4f2a619b05c36b.webp',
    containerClass: 'h-12 md:h-16 max-w-[160px]',
    filterClass: 'brightness-0 grayscale mix-blend-multiply',
  },
  {
    name: 'Malwarebytes',
    alt: 'Malwarebytes logo',
    url: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/8486999bb3e032c063ce633883bbfc28.png',
    containerClass: 'h-12 md:h-16 max-w-[180px]',
    filterClass: 'brightness-0 grayscale mix-blend-multiply',
  },
  {
    name: 'NVIDIA',
    alt: 'Nvidia logo',
    url: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/27489bd2e369229a2d65ea7647889f97.png',
    containerClass: 'h-12 md:h-16 max-w-[200px]',
    filterClass: 'brightness-0 grayscale mix-blend-multiply',
  },
  {
    name: 'Microsoft',
    alt: 'Microsoft logo',
    url: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2Uvd2VicA==/8b7a69c79f06efc64289e680b8caec5f.webp',
    containerClass: 'h-12 md:h-16 max-w-[280px] md:max-w-[340px]',
    filterClass: 'brightness-0 grayscale mix-blend-multiply scale-[1.5] md:scale-[1.8] origin-center',
  },
];

function LogoSet() {
  return (
    <div className="flex gap-16 md:gap-24 items-center pr-16 md:pr-24 shrink-0">
      {LOGOS.map((logo) => (
        <div
          key={logo.name}
          className={`flex-none flex items-center justify-center ${logo.containerClass}`}
        >
          <img
            src={logo.url}
            alt={logo.alt}
            className={`w-auto h-full max-w-full object-contain ${logo.filterClass}`}
            loading="lazy"
            decoding="async"
          />
        </div>
      ))}
    </div>
  );
}

export default function AuthorityMarquee() {
  return (
    <section
      aria-label="Trusted by executive teams — client logos"
      className="w-full bg-[#FFFFFF] border-y border-neutral-200 py-10 md:py-14 px-6 md:px-12"
    >
      <style>{`
        @keyframes custom-marquee {
          0% { transform: translate3d(0, 0, 0); }
          100% { transform: translate3d(-50%, 0, 0); }
        }

        .animate-custom-marquee {
          display: inline-flex;
          animation: custom-marquee 40s linear infinite;
          will-change: transform;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }

        @media (prefers-reduced-motion: reduce) {
          .animate-custom-marquee {
            animation: none;
          }
        }
      `}</style>

      <div className="flex items-center w-full max-w-screen-2xl mx-auto">
        <div className="hidden lg:block shrink-0 relative z-20 bg-white">
          <h2 className="text-[#000000] text-sm md:text-base font-black uppercase tracking-[0.2em] whitespace-nowrap pr-10 border-r-2 border-black">
            TRUSTED BY EXECUTIVE TEAMS
          </h2>
        </div>

        <div className="relative overflow-hidden flex-1 lg:pl-10 before:absolute before:left-0 before:top-0 before:bottom-0 before:w-20 before:z-10 before:bg-gradient-to-r before:from-white before:to-transparent after:absolute after:right-0 after:top-0 after:bottom-0 after:w-20 after:z-10 after:bg-gradient-to-l after:from-white after:to-transparent">
          <div className="animate-custom-marquee pointer-events-none">
            <LogoSet />
            <LogoSet />
          </div>
        </div>
      </div>
    </section>
  );
}